export class Constants {
    public static CLIENT_ID = 'BACK_WEB';
    public static CLIENT_SECRET = 'back_web';

    private static API_BASE_URL = '__API_HOST__';
    private static API_BASE_URL_DEV = 'https://loxo-api-dev.azurewebsites.net';
    //private static API_BASE_URL_DEV = 'http://localhost:5000';

    public static DEFAULT_ITEM_COUNT_PER_PAGE = 25;

    public static DEFAULT_IMAGE_PREVIEW_SIZE = 124; //* Burk
    public static FILTER_ALL_VALUE = 'ALL';

    public static isDev = process.env.NODE_ENV === 'development';

    static getRoot = (): string =>
        Constants.isDev ? Constants.API_BASE_URL_DEV : Constants.API_BASE_URL;

    /**
     * Nombre maximum de jours pour lequel on vérifie la plannification d'un affectation
     */
    public static MAX_DAYS_OF_AFFECTATION = 14;
}
